import React, {Component} from 'react'

export default class AdminPanelView extends Component {
    render () {
        return (
            <p> Admin Panel View</p>
        )
    }
}